import { cn } from "../../../../../lib/utils";
import NumberCounter from "../../../../Brand/DashBoard/PromoteAd/Helpers/NumberCounter";

export const MetricCard = ({
  title,
  value,
  active = false,
  isPercentage = false,
}: {
  title: string;
  value: string | number;
  active?: boolean;
  isPercentage?: boolean;
}) => {
  return (
    <div
      className={cn(
        "border border-[#292F35] p-3 rounded-md min-w-[200px]",
        active
          ? "px-[1.5px] py-[1px] bg-gradient-to-b from-[#FFFFFF] to-[#FF8890]"
          : ""
      )}
    >
      <div className="flex flex-col gap-2 items-center justify-center bg-[#171717] h-full w-full rounded-md">
        <div className="overflow-ellipsis font-[Inter] text-sm not-italic font-medium leading-[22px] text-[#949494]">
          {title}
        </div>
        <div className="text-[#E6E5F1] text-center font-[Inter] text-3xl not-italic font-bold leading-[normal]">
          {isNaN(value as number) ? (
            value
          ) : (
            <>
              <div className="flex items-center justify-center">
                <NumberCounter
                  className="text-[#E6E5F1] text-center font-[Inter] text-3xl not-italic font-bold leading-[normal]"
                  prevNumber={0}
                  targetNumber={value as number}
                  interval={(value as number) / 100}
                  isFloat={isPercentage}
                />
                <span>{isPercentage ? "%" : ""}</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
